import React, { Component } from 'react'
import {
    Button, Form, FormGroup, Label, Input, CustomInput, Col, Row, Progress
} from 'reactstrap'
import './formProduct.css'
import CategoryObj from '../../../../utils/categoria'
const categoria = new CategoryObj()

export default class FormProduct extends Component {
    constructor(props) {
        super(props)

        this.state = {
            categorias: []
        }
        this.onChange = this.onChange.bind(this)
        this.onChangeActivo = this.onChangeActivo.bind(this)
        this.onChangeOferta = this.onChangeOferta.bind(this)
        this.onChangeImg = this.onChangeImg.bind(this)
    }

    onChange(e) {
        const prod = {
            ...this.props.producto,
            [e.target.id]: e.target.value
        }
        this.props.editarProducto(prod)
    }

    onChangeActivo(e) {
        const prod = {
            ...this.props.producto,
            Activo: !this.props.producto.Activo
        }
        this.props.editarProducto(prod)
    }

    onChangeOferta(e) {
        const prod = {
            ...this.props.producto,
            Oferta: !this.props.producto.Oferta
        }
        this.props.editarProducto(prod)
    }

    onChangeImg(e) {
        this.props.guardarImagen(e)
    }

    componentDidMount() {
        const _this = this
        categoria.getCategorias().then(categorias => _this.setState({ categorias }))
    }


    render() {
        // console.log('formulario: ', this.props.producto)
        console.log(this.props.producto.Categoria)
        return (
            <Form className="formEdicion" onSubmit={this.props.guardarCambios}>
                <FormGroup>
                    <Label for="Descripcion">Descripción</Label>
                    <Input onChange={this.onChange} value={this.props.producto.Descripcion} type="text" id="Descripcion" placeholder="Descripción" required />
                </FormGroup>
                <FormGroup>
                    <Label for="Categoria">Categoría</Label>
                    {/* <Input onChange={this.onChange} value={this.props.producto.Categoria} type="text" id="Categoria" placeholder="Categoría" /> */}
                    <CustomInput type="select" onChange={this.onChange} value={this.props.producto.Categoria} id="Categoria" >
                        {
                            this.state.categorias.map(cat => 
                            <option
                                key={cat.id}
                                value={cat.data().Descripcion_lower}
                            >
                                {cat.data().Descripcion}
                            </option>
                            )
                        }
                    </CustomInput>
                </FormGroup>
                <Row form className="rowChecks">
                    <Col md={6}>
                        <Label for="Activo"> </Label>
                        <CustomInput onChange={this.onChangeActivo} checked={this.props.producto.Activo} type="checkbox" id="exampleCustomCheActivockbox2" label="Activo" className="CheckBox" />
                    </Col>
                    <Col md={6}>
                        <Label for="Oferta"> </Label>
                        <CustomInput onChange={this.onChangeOferta} checked={this.props.producto.Oferta} type="checkbox" id="Oferta" label="Oferta" className="CheckBox" />
                    </Col>
                </Row>
                <FormGroup>
                    <Input onChange={this.onChangeImg} className="btn btn-outline-dark btn-sm" type="file" name="file" id="Img" />
                    {
                        this.props.ImgProgress > 0 && <Progress id="ImgProgress" animated color="danger" value={this.props.ImgProgress} />
                    }
                </FormGroup>
                <FormGroup>
                    <Label for="Detalle">Detalle</Label>
                    <Input onChange={this.onChange} value={this.props.producto.Detalle} type="textarea" id="Detalle" />
                </FormGroup>

                <Button color="success">Guardar</Button>
            </Form>
        )
    }


}